<template>
  <div>
    <div class="gray_line">
      <div class="gray_inner">
        <div class="item" :class="tab === 1 ? 'active' : ''" @click="tab = 1">Мои заявки <span
            class="requestsCount">{{ requestsCount }}</span></div>
        <!--                <div class="item" :class="tab === 2 ? 'active' : ''" @click="tab = 2">Заявки (готовые) <span-->
        <!--                        class="requestsCount">{{ requestsCompleteCount }}</span></div>-->
      </div>
    </div>
    <div class="request_content">
      <template v-if="!isLoading">
        <template v-if="requestsItems.length > 0">
          <div class="request_wrapper" v-for="item in requestsItems" v-bind:key="item.id">
            <div class="columns">
              <div class="column images_column is-narrow">
                <div class="images__wrapper">
                  <div v-if="item?.competition?.avatar" class="competition_avatar">

                    <ImageRender
                        :src="get_uploaded_image_asset(item.competition.avatar)"
                    ></ImageRender>

                    <!--																				<img-->
                    <!--                                            :src="'https://script.moviestart.ru/uploads/images/' + item.competition.avatar"-->
                    <!--                                            alt="">-->


                  </div>
                  <div class="competition_avatar" v-else><img
                      src="https://script.moviestart.ru/images/iconfinder_gallery_2199104.png">
                  </div>
                  <div class="project_avatar" v-if="item?.project?.afisha">
                    <!--																				<img :src="'https://script.moviestart.ru/uploads/images/'+item.project.afisha">-->
                    <ImageRender :src="getProjectAvatar(item.project.afisha)"></ImageRender>
                  </div>
                  <div class="project_avatar" v-else><img
                      :src="'https://script.moviestart.ru/images/default_project.png'"></div>
                </div>
              </div>
              <div class="column content_column">
                <div class="info_block">
                  <div class="info_block__header">Заявка</div>
<!--	                <template v-if="currentUserId == '12'">-->
<!--                    <template v-if="item.project && item.project.type === null">-->
<!--                      <p><a :href="`/project/${item.project.id}/update/${item.competition.id}`">Редактировать</a></p>-->
<!--                    </template>-->
<!--	                </template>-->
	                
	                

                  <table>
                    <tr class="info_block__item">
                      <td class="col1">Конкурс</td>
                      <td class="col2">{{ item.competition.name }}</td>
                    </tr>
                    <tr v-if="!isCompany" class="info_block__item">
                      <td class="col1">Категория</td>
                      <td class="col2">{{ item.category.name }}</td>
                    </tr>
                    <tr class="info_block__item">
                      <td class="col1">Дата подачи</td>
                      <td class="col2">{{ formattedDate(item.created) }}</td>
                    </tr>
                    <tr class="info_block__item" v-if="item.project">
                      <td class="col1">Название проекта</td>
                      <td class="col2">
	                      <template v-if="item.project.name">
		                      {{ item.project.name }}
		                      <template v-if="!item.project.type">
			                      <p><a target="_blank" :href="`/project/${item.project.id}/update/${item.competition.id}`">Посмотреть заявку</a></p>
		                      </template>
	                      </template>
                      </td>
                    </tr>

                  </table>
                  <!--                          <div class="info_block__item"><span class="col1">Конкурс</span> <span class="col2">{{ item.competition.name }}</span></div>-->
                  <!--                          <div class="info_block__item"><span class="col1">Номинация</span> <span class="col2">{{ item.category.name }}</span></div>-->
                  <!--                          <div class="info_block__item"><span class="col1">Дата подачи</span> <span class="col2">{{ formattedDate(item.created) }}</span></div>-->
                  <!--                          <div class="info_block__item"><span class="col1">Название проекта</span> <span class="col2">{{ item.project.name }}</span></div>-->
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <p>У вас нет отправленных заявок</p>
        </template>

      </template>
      <div v-else class="request_wrapper">
        <div class="columns">
          <div class="column">
            <Spin></Spin>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script setup>
import axios from "axios";
import {ref, computed, onMounted} from "vue";
import moment from 'moment';
import {Spin} from "ant-design-vue";
import ImageRender from "@/components/Base/ImageRender.vue";
import ImageService from "@/services/ImageService";

let requests = ref([]);
let requestsComplete = ref([]);

let tab = ref(1);
let isLoading = ref(false);

function formattedDate(date) {
  return moment(date).format('DD.MM.YYYY');
}

const currentUserId = computed(() => {
  return window.currentUserId;
})

async function getRequests() {
  isLoading.value = true;
  if (isCompany.value) {
    const response1 = await axios.get('/competition/getProjectInfosByCompany');
    requests.value = response1.data;
  } else {
    const response1 = await axios.get('/competition/getProjectInfosByUserAll');
    requests.value = response1.data;

    // const response2 = await axios.get('/competition/getProjectInfosByUserComplete');
    // requestsComplete.value = response2.data;
  }
  isLoading.value = false;
}

onMounted(() => {
  getRequests();
})


const isCompany = computed(() => {
  return window.isCompany
})

const requestsCount = computed(() => {
  return requests.value.length;
})

// const requestsCompleteCount = computed(() => {
//   return requestsComplete.value.length;
// })

const requestsItems = computed(() => {
  if (tab.value === 1) {
    return requests.value;
  } else (tab.value === 2)
  {
    return requestsComplete.value;
  }
})

function get_uploaded_image_asset(path) {
  return ImageService.getCompetitionImagePath(path);
}

function getProjectAvatar(avatar) {
  return ImageService.getProjectImagePath(avatar);
}

</script>

<style scoped>
.competition_avatar:deep img {
    max-width: 255px;
    border-radius: 10px;
}

.project_avatar:deep img {
    max-width: 106px;
    border-radius: 10px;
    border: 1px solid #DB7F1C;
    box-shadow: 0px 0px 70px 0px rgba(239, 162, 79, 0.52) inset, 0px 12px 24px 0px rgba(0, 0, 0, 0.24);
    backdrop-filter: blur(40px);
}

.info_block__header {
    color: #1D232D;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    margin-top: -10px;
    margin-bottom: 20px;
}

.info_block__item {
    margin-bottom: 15px;
}

.info_block__item .col1 {
    color: rgba(29, 35, 45, 0.50);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    width: 150px;
}

.info_block__item .col2 {
    color: #1D232D;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
}

.images__wrapper {
    position: relative;
}

.project_avatar {
    position: absolute;
    right: -90px;
    top: 10px;
}

.images_column {
    margin-right: 100px;
}

.request_wrapper {
    margin-bottom: 15px;
}

.content table td {
    border: 0;
    padding: 0;
}

.content table td:not(:last-child) {
    padding-bottom: 15px;
}

.gray_line {
    background: #E3E9F3;
    padding: 20px;
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
    padding-bottom: 0;
}

.cabinet_page .content {
    padding: 0;
    /*overflow: hidden;*/
}

.request_content {
    padding: 30px 20px;
}

</style>